/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortfolioTemplateRepresentation
 */
export interface PortfolioTemplateRepresentation {
    /**
     * 
     * @type {string}
     * @memberof PortfolioTemplateRepresentation
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioTemplateRepresentation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioTemplateRepresentation
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioTemplateRepresentation
     */
    created: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioTemplateRepresentation
     */
    updated: number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioTemplateRepresentation
     */
    companyKey?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PortfolioTemplateRepresentation
     */
    generatorKeys?: Array<string>;
}

/**
 * Check if a given object implements the PortfolioTemplateRepresentation interface.
 */
export function instanceOfPortfolioTemplateRepresentation(value: object): value is PortfolioTemplateRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('updated' in value) || value['updated'] === undefined) return false;
    return true;
}

export function PortfolioTemplateRepresentationFromJSON(json: any): PortfolioTemplateRepresentation {
    return PortfolioTemplateRepresentationFromJSONTyped(json, false);
}

export function PortfolioTemplateRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioTemplateRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'created': json['created'],
        'updated': json['updated'],
        'companyKey': json['companyKey'] == null ? undefined : json['companyKey'],
        'generatorKeys': json['generatorKeys'] == null ? undefined : json['generatorKeys'],
    };
}

export function PortfolioTemplateRepresentationToJSON(json: any): PortfolioTemplateRepresentation {
    return PortfolioTemplateRepresentationToJSONTyped(json, false);
}

export function PortfolioTemplateRepresentationToJSONTyped(value?: PortfolioTemplateRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'name': value['name'],
        'description': value['description'],
        'created': value['created'],
        'updated': value['updated'],
        'companyKey': value['companyKey'],
        'generatorKeys': value['generatorKeys'],
    };
}

